import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=d5f0247c"
import script from "./PerformanceChart.vue?vue&type=script&lang=js"
export * from "./PerformanceChart.vue?vue&type=script&lang=js"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=d5f0247c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports